document.addEventListener('DOMContentLoaded', function () {
  initQtySteppers();
  initGallery();
  initProductVariants();
  initCartAutoSubmit();
  initDiscountCode();
  initRecoverPanel();
  initSliders();
});

function initQtySteppers() {
  document.querySelectorAll('.gc-qty').forEach(function (box) {
    var input = box.querySelector('input[type=number]');
    if (!input) return;
    var minus = box.querySelector('[data-qty-minus]');
    var plus = box.querySelector('[data-qty-plus]');
    var min = parseInt(input.min, 10) || 0;

    if (minus) {
      minus.addEventListener('click', function () {
        var next = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var next = (parseInt(input.value, 10) || 1) + 1;
        input.value = Math.min(next, 10);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });
}

function initGallery() {
  var main = document.querySelector('[data-main-media]');
  if (!main) return;
  var mainImg = main.querySelector('[data-main-image]');
  var mainShape = main.querySelector('[data-main-shape]');
  var mainCaption = main.querySelector('[data-main-caption]');

  document.querySelectorAll('.gc-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.gc-thumb').forEach(function (o) { o.classList.remove('active'); });
      thumb.classList.add('active');

      var image = thumb.getAttribute('data-image');
      var shape = thumb.getAttribute('data-shape');
      var caption = thumb.getAttribute('data-caption');

      if (image && mainImg) mainImg.src = image;
      if (shape && mainShape) mainShape.className = 'shape ' + shape;
      if (caption && mainCaption) mainCaption.textContent = caption;
    });
  });
}

function formatMoneyTL(cents) {
  return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
}

function initProductVariants() {
  var form = document.getElementById('gc-product-form');
  var variantsEl = document.querySelector('[data-product-variants-json]');
  if (!form || !variantsEl) return;

  var variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (e) {
    return;
  }

  var selectors = Array.prototype.slice.call(form.querySelectorAll('[data-option-selector]'));
  if (!selectors.length) return;

  function getSelectedOptions() {
    var positions = {};
    selectors.forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-option-position'), 10);
      if (el.type === 'radio') {
        if (el.checked) positions[pos] = el.value;
      } else {
        positions[pos] = el.value;
      }
    });
    var maxPos = Math.max.apply(null, Object.keys(positions).map(Number));
    var arr = [];
    for (var i = 0; i <= maxPos; i++) arr.push(positions[i]);
    return arr;
  }

  function findVariant(options) {
    return variants.filter(function (v) {
      return v.options.length === options.length && v.options.every(function (val, idx) {
        return val === options[idx];
      });
    })[0];
  }

  function updateUI(variant) {
    var variantIdInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addText = form.querySelector('[data-add-to-cart-text]');
    var skuEl = document.querySelector('[data-sku]');

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Bu kombinasyon mevcut değil';
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoneyTL(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoneyTL(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) addBtn.disabled = !variant.available;
    if (addText) addText.textContent = variant.available ? ('Sepete Ekle — ' + formatMoneyTL(variant.price)) : 'Tükendi';
    if (skuEl) skuEl.textContent = variant.sku || '—';
    if (variant.featured_image) {
      var mainImg = document.querySelector('[data-main-image]');
      if (mainImg) mainImg.src = variant.featured_image.src;
    }
  }

  selectors.forEach(function (el) {
    el.addEventListener('change', function () {
      var block = el.closest('.gc-option-block');
      if (block) {
        var valueLabel = block.querySelector('[data-option-current-value]');
        if (valueLabel) valueLabel.textContent = el.value;
      }
      updateUI(findVariant(getSelectedOptions()));
    });
  });
}

function initCartAutoSubmit() {
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
}

function initDiscountCode() {
  var input = document.querySelector('[data-discount-input]');
  var apply = document.querySelector('[data-discount-apply]');
  if (!input || !apply) return;
  apply.addEventListener('click', function () {
    var code = input.value.trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  });
}

function initRecoverPanel() {
  var toggle = document.querySelector('[data-recover-toggle]');
  var cancel = document.querySelector('[data-recover-cancel]');
  var loginPanel = document.querySelector('[data-login-panel]');
  var recoverPanel = document.querySelector('[data-recover-panel]');
  if (!toggle || !recoverPanel || !loginPanel) return;

  toggle.addEventListener('click', function () {
    loginPanel.hidden = true;
    recoverPanel.hidden = false;
  });
  if (cancel) {
    cancel.addEventListener('click', function () {
      recoverPanel.hidden = true;
      loginPanel.hidden = false;
    });
  }
}

function initSliders() {
  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var track = root.querySelector('[data-slider-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    var cur = root.querySelector('[data-slider-current]');
    var tot = root.querySelector('[data-slider-total]');
    var dotsBox = root.querySelector('[data-slider-dots]');
    var centered = track.hasAttribute('data-slider-center');
    var dots = [];
    var ticking = false;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    if (tot) tot.textContent = pad(slides.length);
    if (dotsBox) {
      slides.forEach(function (s, i) {
        var d = document.createElement('i');
        dotsBox.appendChild(d);
        dots.push(d);
      });
    }

    function activeIndex() {
      var c = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bd = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }

    function update() {
      ticking = false;
      if (centered) {
        var a = activeIndex();
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === a); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
        if (cur) cur.textContent = pad(a + 1);
      } else {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
    }

    function go(dir) {
      if (centered) {
        var t = Math.max(0, Math.min(slides.length - 1, activeIndex() + dir));
        var s = slides[t];
        track.scrollTo({ left: s.offsetLeft + s.offsetWidth / 2 - track.clientWidth / 2, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);

    update();
  });
}
